import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { useTranslation } from 'react-i18next';

export const DayHeader = (props) => {
    const { t } = useTranslation();
    const classNames = className({
        'odf-calendar-header-day': true,
        'odf-calendar-day-weekend': props.weekDay === 0 || props.weekDay === 6,
    });
    const weekDayShort = t('calendar.weekDaysShort').split(',')[props.weekDay];

    return <div className={classNames}>{weekDayShort}</div>;
};

DayHeader.propTypes = {
    weekDay: PropTypes.number.isRequired,
};
